import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ScheduleList from './schedule_list';
import ScheduleDetail from './schedule_detail';

class Schedules extends Component {
  componentDidMount(){
  }
  render() {
    //console.log(this.context);
    var params = this.context.router.route.match.params;
    var view;
    if(params.action===undefined){
      view = <ScheduleList/>;
    }else{
      if(params.id===undefined){
        view = <ScheduleDetail/>;
      }else{
        view = <ScheduleDetail action={params.action}/>;
      }
    }
    return (
      <div className="page-wrapper">{view}</div>
    );
  }
}

Schedules.contextTypes = {
  router: PropTypes.object
};

export default Schedules;
